import { StateType } from './reducers'
import { CoreReducer } from './core'
import { LoginReducer } from './login'
import * as Sentry from '@sentry/react'

export const loader = (): Partial<StateType> | null => {
  const loadedStateString = window.localStorage.getItem('globalState')
  const loadedState =
    typeof loadedStateString === 'string' && loadedStateString?.length > 3
      ? ((<unknown>JSON.parse(loadedStateString)) as StateType)
      : null
  const state = {
    core: CoreReducer.initialState,
    login: loadedState?.login?.sessions ? loadedState.login : LoginReducer.initialState,
    // login: loadedState.login,
    // login: LoginReducer.initialState,
  }
  window.depotoEnv = <'prod' | 'stage' | 'dev' | 'custom'>state.core.core.services.oauth.session.clientType
  state.core.selectedCheckoutId = loadedState?.core?.selectedCheckoutId || 0
  state.core.selectedDetailCheckoutId = loadedState?.core?.selectedDetailCheckoutId || 0
  state.core.currentOrder = loadedState?.core?.currentOrder
  state.core.orderVouchers = loadedState?.core?.orderVouchers || []
  return state
}

export const persister = async (state: Partial<StateType> | any) => {
  const stateWithoutCore: any = {
    login: state.login,
    core: {
      selectedCheckoutId: state.core.selectedCheckoutId || 0,
      selectedDetailCheckoutId: state.core.selectedDetailCheckoutId || 0,
      currentOrder: state.core.currentOrder,
      orderVouchers: state.core.orderVouchers || [],
    },
  }
  try {
    await window.localStorage.setItem('globalState', JSON.stringify(stateWithoutCore))
  } catch (e) {
    Sentry.captureException(e)
  }
}

export const asyncer = (dispatch: any, state: any) => (action: any) =>
  typeof action === 'function' ? action(dispatch, state) : dispatch(action)

export const logger = (action: object, prevState: object, currentState: object) => {
  console.groupCollapsed('Logger')
  console.log('%c Action:', 'color: blue', action)
  console.log('%c Previous State:', 'color: red', prevState)
  console.log('%c Current State:', 'color: green', currentState)
  console.groupEnd()
  // console.log(action, prevState, currentState)
}
